import { render, staticRenderFns } from "./AnmeldungUebertragenModal.vue?vue&type=template&id=5980be54&scoped=true"
import script from "./AnmeldungUebertragenModal.vue?vue&type=script&lang=js"
export * from "./AnmeldungUebertragenModal.vue?vue&type=script&lang=js"
import style0 from "./AnmeldungUebertragenModal.vue?vue&type=style&index=0&id=5980be54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5980be54",
  null
  
)

export default component.exports